import React, { useState, useEffect } from "react";
import { Navbar as BootstrapNavbar, Nav, Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <BootstrapNavbar expand="lg" className={`custom-navbar ${isScrolled ? "navbar-transparent" : ""}`}>
      <Container>
        <BootstrapNavbar.Toggle aria-controls="menu-navbar">
          <span className="hamburger">
            <span></span>

            <span></span>

            <span></span>
          </span>
        </BootstrapNavbar.Toggle>

        <BootstrapNavbar.Collapse id="menu-navbar">
          <Nav className="navbar-links">
            <Nav.Link href="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
              Home
            </Nav.Link>

            <Nav.Link href="/salon" className={`nav-link ${location.pathname === "/salon" ? "active" : ""}`}>
              Salone
            </Nav.Link>

            <Nav.Link href="/service" className={`nav-link ${location.pathname === "/service" ? "active" : ""}`}>
              Servizi
            </Nav.Link>

            <Nav.Link href="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}>
              Contatti
            </Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
}

export default Navbar;
